import React from "react";

const ChiliPiperIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.9331 9.40645C29.9237 9.64187 34.4198 10.4981 36.4783 12.0394L36.8881 11.3561C36.3919 10.8978 35.2639 9.87107 34.7223 9.43085C35.452 7.9269 36.5345 3.95891 35.0275 0.118591L33.5273 1.8937C33.5219 3.4459 33.129 6.93243 31.6028 8.46091L28.3439 8.4492L27.9331 9.40645Z",
  fill: "#0067E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5694 32.4886C8.02635 35.9592 4.4205 38.4786 1.88794 39.8617C7.9767 40.0745 13.3093 38.818 17.8943 36.7211C15.6271 35.5462 13.5071 34.1234 11.5694 32.4886Z",
  fill: "#F8C030"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.0131 35.1058C18.3047 33.8937 15.7815 32.3375 13.4983 30.4922C15.7247 28.055 17.8406 25.2425 19.549 22.1034C20.2668 22.574 21.0034 23.0184 21.7573 23.435C19.9832 26.8028 18.0595 29.5422 16.8567 31.0064C19.2497 29.533 21.4072 26.9786 23.2114 24.1933C25.6447 25.3884 28.2397 26.3012 30.9547 26.8892C28.2911 29.8908 24.9795 32.8022 21.0131 35.1058Z",
  fill: "#F8C030"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.3252 13.6536C27.6563 15.6325 26.3866 18.6974 24.6649 21.7753C27.2438 23.033 30.0033 23.9739 32.8941 24.5478C35.4468 21.2439 37.2227 17.9928 38.2311 15.4763C34.1179 11.4074 26.5711 10.5494 23.3119 10.629C22.9319 13.8103 22.0375 16.7997 20.8029 19.5688C21.5168 20.041 22.2493 20.4869 22.9989 20.9052C24.1336 18.4096 25.0986 15.691 25.6119 12.9591C26.2002 12.9612 27.5668 13.103 28.3252 13.6536Z",
  fill: "#0067E3"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(ChiliPiperIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;